export const types = {
  SET_DDEX_STORES: "SET_DDEX_STORES",
};

export const setDdexStores = payload => ({
  type: types.SET_DDEX_STORES,
  payload,
});
